export const QUESTION_TYPES = [
    {
        label: 'Refactor Code',
        value: 'refactorCode',
    },
    {
        label: 'Troubleshoot Code',
        value: 'troubleshootCode',
    },
];

export const QUESTION_DIFFICULTY = [
    {
        label: 'Easy',
        value: 'easy',
    },
    {
        label: 'Medium',
        value: 'medium',
    },
    {
        label: 'Hard',
        value: 'hard',
    },
];

export const QUESTION_LANGUAGES = [
    {
        label: 'Javascript',
        value: 'javascript',
    },
    {
        label: 'Java',
        value: 'java',
    },
    {
        label: 'Python',
        value: 'python',
    },
    {
        label: 'C++',
        value: 'cpp',
    },
    {
        label: 'HTML',
        value: 'html',
    },
];

export const QUESTION_STATUS = [
    {
        label: 'Todo',
        value: 'todo',
    },
    {
        label: 'Attempted',
        value: 'attempted',
    },
];